<div class="confirmation-title">
  <mat-icon>error_outline</mat-icon>
  <h2>{{ title }}</h2>
</div>

<div class="mat-dialog-content">
  <p class="message">
    {{ message }}
    <span *ngIf="data.location === 'home' && !lastClockIn">{{
      location_home
    }}</span>
    <span *ngIf="data.location === 'office' && !lastClockIn">{{
      location_office
    }}</span>
    {{ message_two }}
  </p>
  <p class="warning-msg">{{ warningMsg }}</p>
</div>

<div class="mat-dialog-actions">
  <button mat-button (click)="onCancel()">
    {{ 'attendance.attendance-card.confirmation.cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onConfirm()">
    {{ 'attendance.attendance-card.confirmation.yes' | translate }}
  </button>
</div>
